import Vue from 'vue'
import VueRouter from 'vue-router'
import BookingApp from '@/components/Booking'
import BookingDetail from '@/components/BookingDetail'
import MultiBook from '@/components/multiBook'
import payment from '@/components/payment'
import paymentComplete from '@/components/paymentComplete'
import multiRoomBookingDetail from '@/components/multiRoomBookingDetail'
import offlinePayment from '@/components/offlinePayment'
import roomDetails from '@/components/roomDetails'
import setUps from '@/components/setUp'
import multiproperty from '@/components/multiproperty'
import manageBooking from '@/components/manageBooking/ManageBooking'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'booking',
      component: BookingApp
    },
    {
      path: '/multi-property',
      name: 'multi-property',
      component: multiproperty
    },
    {
      path: '/booking-detail',
      name: 'booking-detail',
      component: BookingDetail
    },
    {
      path: '/multi-room-selection',
      name: 'multi-book',
      component: MultiBook
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/payment-complete',
      name: 'payment-complete',
      component: paymentComplete
    },
    {
      path: '/multi-room-book-detail',
      name: 'multi_room_detail',
      component: multiRoomBookingDetail
    },
    {
      path: '/payment2-complete/',
      name: 'offline-payment',
      component: offlinePayment
    },
    {
      path: '/room-details',
      name: 'room-details',
      component: roomDetails
    },
    {
      path: '/set-ups',
      name: 'setups',
      component: setUps
    },
    {
      path: '/manage-booking',
      name: 'manage-booking',
      component: manageBooking
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'hash',
  base: 'http://localhost:8080/'
})



// WEBPACK FOOTER //
// ./src/router/index.js